<template>
    <painel titulo="Solicitação" icone="pi pi-file" :mostrarRefresh="false">
        <erros-box :erros="erros"></erros-box>
        <div class="formgrid grid p-fluid">
            <div class="field col-12 md:col-4">
                <label class="required">Gestor</label>
                <Dropdown
                    v-model="gestor"
                    :options="usuarios"
                    filter
                    filterMatchMode="startsWith"
                    class="outline-none"
                    optionLabel="nome"
                    placeholder="Selecione"
                    :disabled="desabilitaForm"
                    showClear
                />
            </div>
            <div class="field col-12 md:col-2">
                <label class="required">Número da Matricula</label>
                <InputText
                    type="number"
                    ref="inputMatricula"
                    @input="v$.numeroMatricula.$touch(), defineTotalCaracteres($event, 8)"
                    v-model="numeroMatricula"
                />
                <small class="p-error" v-if="v$.numeroMatricula.$error">O número da Matrícula é obrigatório.</small>
            </div>
            <div class="field col-12 md:col-4">
                <label class="required">Email</label>
                <InputText type="text" v-model="emailGestor" :disabled="desabilitaForm" @input="v$.emailGestor.$touch()" />
                <small class="p-error" v-if="v$.emailGestor.$error"> O email do responsável é obrigatório.</small>
            </div>
            <div class="field col-12 md:col-2">
                <label class="required">Unidade</label>
                <Dropdown
                    v-model="unidade"
                    :options="unidades"
                    filter
                    class="outline-none"
                    optionLabel="siglaUnidade"
                    placeholder="Selecione"
                    :disabled="desabilitaForm"
                />
            </div>

            <div class="field col-12 md:col-4">
                <label>Evento</label>
                <InputText type="text" v-model="evento" @input="v$.evento.$touch()" maxlength="100" :disabled="desabilitaForm" />
            </div>
            <div class="field col-12 md:col-2">
                <label class="required">Código do SEAP</label>
                <InputText type="text" v-model="codigoSeap" @input="v$.codigoSeap.$touch()" maxlength="100" :disabled="desabilitaForm" />
                <small class="p-error" v-if="v$.codigoSeap.$error"> O código SEAP é obrigatório.</small>
            </div>
            <div class="field col-12 md:col-3">
                <label class="required">Data de Entrada do SEAP</label>
                <Calendar v-model="dataEntrada" showIcon :disabled="desabilitaForm" />
            </div>
            <div class="field col-12 md:col-3">
                <label class="required">Data da Aprovação do SEAP</label>
                <Calendar v-model="dataAprovacao" showIcon :disabled="desabilitaForm" />
            </div>

            <div class="field col-12 md:col-6">
                <label>Observação</label>
                <Textarea type="text" v-model="observacao" @input="v$.observacao.$touch()" />
            </div>
            <div class="field col-12 md:col-6">
                <label>Objeto do TR</label>
                <Textarea type="text" v-model="objetoSolicitacao" :disabled="desabilitaForm" maxlength="1000" @input="v$.objetoSolicitacao.$touch()" />
            </div>
            <div class="field col-12">
                <label class="field col-12 md:col-12 pl-0 required">Anexos</label>
                <FileUpload
                    ref="fileUpload"
                    :multiple="true"
                    :customUpload="true"
                    @uploader="arquivoSelecionado"
                    mode="basic"
                    chooseLabel="Selecionar o arquivo"
                    :auto="true"
                />
                <br />
                <div v-for="(anexo, index) in anexos" :key="index">
                    <strong>{{ anexo.name }}</strong>
                    <i class="pi pi-trash p-error icon-button ml-2" style="font-size: 1.2rem" @click="limparArquivo(index)"></i>
                </div>
            </div>
        </div>
        <slot name="botoes"></slot>
        <Button label="Cancelar" icon="pi pi-times-circle" class="p-button-secondary" @click="cancelar()" />
        <Button label="Salvar" icon="pi pi-check-circle" class="ml-2 p-button-primary" @click="confirmarSalvar()" :disabled="v$.$invalid" />
    </painel>
</template>

<script>
import { required, email, maxLength } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import solicitacoesServices from '../services';

export default {
    setup() {
        return { v$: useVuelidate() };
    },

    props: {
        acao: {
            type: String,
        },

        solicitacao: {
            type: Object,
        },

        erros: {
            type: Array,
        },
    },

    emits: ['salvar', 'cancelar'],

    data() {
        return {
            gestor: null,
            numeroMatricula: '',
            emailGestor: null,
            objetoSolicitacao: null,
            unidade: null,
            dataEntrada: null,
            dataAprovacao: null,
            codigoSeap: null,
            evento: null,
            observacao: null,
            usuarios: [],
            documento: null,
            anexos: [],
            nomeArquivo: null,
            unidades: [],
        };
    },

    validations() {
        return {
            gestor: { required },
            numeroMatricula: {
                required,
                maxLength: maxLength(8),
            },
            emailGestor: { required, email },
            unidade: { required },
            dataEntrada: { required },
            dataAprovacao: { required },
            codigoSeap: { required },
            anexos: { required },
            observacao: { maxlength: maxLength(500) },
            objetoSolicitacao: { maxlength: maxLength(1000) },
        };
    },

    methods: {
        atualizarValorTotal(event) {
            const inputValue = event.target.value;
            this.numeroMatricula = inputValue.slice(0, 8);
            event.target.value = this.numeroMatricula;
        },

        defineTotalCaracteres(event, numeroCaracteres) {
            let campo = event.target.value;

            if (numeroCaracteres === 8) {
                this.numeroMatricula = campo.slice(0, numeroCaracteres);
                event.target.value = this.numeroMatricula;
            }
            if (numeroCaracteres === 500) {
                this.observacao = campo.slice(0, numeroCaracteres);
                event.target.value = this.observacao;
            }
            if (numeroCaracteres === 1000) {
                this.objetoSolicitacao = campo.slice(0, numeroCaracteres);
                event.target.value = this.objetoSolicitacao;
            }
        },

        obterUsuarios() {
            this.$store.dispatch('addRequest');
            solicitacoesServices.obterUsuarios().then((response) => {
                if (response && response.success) {
                    const uniqueUsuarios = response.data.filter((usuario, index, self) => index === self.findIndex((u) => u.nome === usuario.nome));
                    this.usuarios = uniqueUsuarios;
                }
                this.$store.dispatch('removeRequest');
            });
        },

        obterUnidades() {
            this.$store.dispatch('addRequest');
            solicitacoesServices.obterUnidades().then((response) => {
                if (response.data.length > 0 && response.success) {
                    this.unidades = response.data;
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Erro ao carregar unidades',
                        detail: 'Erro ao trazer dados do RM.',
                        life: 3000,
                    });
                }
                this.$store.dispatch('removeRequest');
            });
        },

        arquivoSelecionado(event) {
            for (let file of event.files) {
                if (file.size > 30 * 1024 * 1024) {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Erro ao carregar arquivo',
                        detail: 'O tamanho do arquivo deve ser inferior a 10MB.',
                        life: 3000,
                    });
                    continue;
                }
                this.anexos.push(file);
            }
            this.$refs.fileUpload.clear();
        },

        limparArquivo(index) {
            this.anexos.splice(index, 1);
            this.arquivoAlterado = true;
        },

        cancelar() {
            this.$emit('cancelar');
        },

        confirmarSalvar() {
            this.$confirm.require({
                message: `Tem certeza que deseja ${this.acao.toLowerCase()} a solicitação?`,
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.salvar();
                },
            });
        },

        salvar() {
            let solicitacaoDto = {
                solicitacaoId: null,
                gestor: this.gestor?.nome,
                numeroMatricula: this.numeroMatricula,
                emailResponsavel: this.emailGestor,
                objetoSolicitacao: this.objetoSolicitacao,
                unidade: this.unidade.siglaUnidade,
                dataEntrada: this.$dateFormat(this.dataEntrada, 'YYYY-MM-DD'),
                dataAprovacao: this.$dateFormat(this.dataAprovacao, 'YYYY-MM-DD'),
                codigoSeap: this.codigoSeap,
                evento: this.evento,
                observacao: this.observacao,
                arquivos: this.anexos,
            };
            this.$emit('salvar', solicitacaoDto);
        },
    },

    mounted() {
        this.obterUsuarios();
        this.obterUnidades();
    },

    watch: {
        gestor() {
            if (!this.gestor) {
                this.numeroMatricula = '';
                this.unidade = '';
                this.emailGestor = '';
                return;
            }

            this.emailGestor = this.gestor.email;
            this.numeroMatricula = this.gestor.chapa;

            const gestorComSuaUnidade = this.usuarios.filter((usuario) => usuario.email == this.gestor.email);
            const unidadeDoGestor = this.unidades.filter((unidade) => unidade.siglaUnidade == gestorComSuaUnidade[0]?.siglaUnidade);

            this.unidade = unidadeDoGestor[0];
        },
    },
};
</script>

<style scoped>
.p-inputtext[type='number']::-webkit-inner-spin-button,
.p-inputtext[type='number']::-webkit-outer-spin-button,
.p-inputtext[type='number']::-webkit-clear-button {
    display: none;
}

textarea {
    max-width: 100%;
    min-width: 100%;
}
</style>
